import { service } from '@ember/service';
import Route from '@ember/routing/route';

export default class SiteBillingPendingInsuranceRoute extends Route {
  @service router;
  @service currentPractice;
  @service clientInsuranceAccess;

  beforeModel() {
    super.beforeModel(...arguments);

    if (!this.clientInsuranceAccess.claimAssistantOrManagedBilling) {
      return this.router.transitionTo('site.billing');
    }

    if (!this.currentPractice.get('insuranceInfoDocumentRequestEnabled')) {
      return this.router.transitionTo('site.billing.insurance');
    }
  }

  model() {
    return this.modelFor('site.billing');
  }
}
